import React, { useCallback, useContext } from 'react';
import { Snackbar } from './Snackbar';
import { initialState, reducer } from './snackbarReducer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SnackbarDispatchContext = /*#__PURE__*/React.createContext(undefined);
export const SnackbarProvider = ({
  children
}) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const snackbarEntry = state.snackbar;
  return /*#__PURE__*/_jsxs(SnackbarDispatchContext.Provider, {
    value: dispatch,
    children: [children, snackbarEntry && /*#__PURE__*/_jsx(Snackbar, {
      snackbarEntry: snackbarEntry,
      dispatch: dispatch
    })]
  });
};
export const useSnackbarDispatch = () => {
  const context = useContext(SnackbarDispatchContext);
  if (context === undefined) {
    throw new Error('useSnackbarDispatch must be used within a SnackbarProvider');
  }
  return context;
};
export const useSnackbar = () => {
  const dispatch = useSnackbarDispatch();
  return useCallback(entry => dispatch({
    type: 'add-snackbar',
    snackbarEntry: entry
  }), [dispatch]);
};